import React, { useEffect, useState } from "react";
import FooterAdmin from "./footer";
import HeaderAdmin from "./header";
import SlideNav from "./slidenav";
import $ from 'jquery'
import axios from "axios";
import { toast } from "react-toastify";


const Category = () => {

    const [categoryContent, setCategoryContent] = useState([]);
    const getCategoryContent = async (id) => {
        const { data } = await axios.get(`/categoryapi`);
        setCategoryContent(data);
    };

    const upload = () => {
        $('<input type="file"  />').click().on('change', async (e) => {
            for (let i = 0; i < e.target.files.length; i++) {
                var formData = new FormData();
                formData.append('file', e.target.files[i]);
                await axios.post('/upload', formData).then(res => {
                    if (res.data !== "err") {
                        $("#attachment").val(res.data);
                        $(`#upattachment`).append(`<img src="../../../${res.data}" class="img-thumbnail viewImg" alt=${res.data} />`)
                    }
                    $('.viewImg').click(function () {
                        $(this).remove()
                        axios.delete(`/upload/${$(this).attr('alt')}`).then(res => {
                            if (res.data !== "err") {
                                $("#attachment").val('');
                            } else {
                                toast.error('Failed');
                            }
                        })
                    })
                })
            }
        })
    }

    useEffect(() => {
        axios.get("/auth").then((res) => {
            if (res.data == "err") {
                window.location.href = '/login';
            }
            else {
                getCategoryContent();
            }
        });
    }, []);
    return (
        <>
            <SlideNav />
            <div class="canvas">

                <HeaderAdmin />
                <section class="page-wrapper innerpage-section-padding">
                    <div class="container-fluid">
                        <div class="tables-page">
                            <div class="heading-1">
                                {/* Button trigger modal */}
                                <button type="button" className="btn btn-secondary   btn-primary buttons-sizes-1 btn-block" data-toggle="modal" data-target="#exampleModalCenter10">
                                    <i
                                        class="fa fa-plus"></i> New Category
                                </button>
                                {/* Modal */}

                                <div className="dialog-box-wrapper form-dialog half-width">
                                    <div className="modal fade text-left" id="exampleModalCenter10" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenter10Title" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header ">
                                                    <h4>Add</h4>
                                                    <button type="button" className="btn text-danger" data-dismiss="modal">X</button>
                                                </div>
                                                <form className="form-sample" onSubmit={(e) => {
                                                    e.preventDefault();
                                                    const formData = new FormData(e.target);
                                                    const data = Object.fromEntries(formData);
                                                    axios.post("/categoryapi", data).then(res => {
                                                        if (res.data !== 'err') {
                                                            window.$('#exampleModalCenter10').modal('hide');
                                                            // $('#expenses_header_id').val(res.data[0]);
                                                            getCategoryContent();
                                                        }
                                                    })
                                                }}>
                                                    <div className="modal-body">
                                                        <div className="form-group">
                                                            <label htmlFor="name_krd">Kurdish Name</label>
                                                            <input id="name_krd" className="form-control" type="text" name="name_krd" required placeholder="ناوی کەتیگۆری" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="name_ar">Arabic Name</label>
                                                            <input id="name_ar" className="form-control" type="text" name="name_ar" required placeholder="فئات" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="name_en">English  Name</label>
                                                            <input id="name_en" className="form-control" type="text" name="name_en" required placeholder="Category" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="priority">Priority</label>
                                                            <input id="priority" className="form-control" type="number" name="priority" required placeholder="Priority" />
                                                        </div>

                                                        <div className="mb-3">
                                                            <label> Image Icon</label>
                                                            <input type="hidden" name="cover" required id="attachment" />
                                                            <div className="form-control text-center" onClick={() => upload()}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                                                            </div>
                                                            <br />
                                                            <div align="center" id="upattachment"></div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                                                        <button type="submit" className="btn btn-success">Save</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-wrapper">
                                <table class="table">
                                    <thead class="thead-light">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Category Krd</th>
                                            <th scope="col">Category Ar</th>
                                            <th scope="col">Category Eng</th>
                                            <th scope="col">Logo</th>
                                            <th scope="col">priority</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {categoryContent && categoryContent.map((item) => (
                                            item.id ? (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{item.name_krd}</td>
                                                    <td>{item.name_ar}</td>
                                                    <td>{item.name_en}</td>
                                                    <td>{item.cover ? (
                                                        <a href={`../../../${item.cover}`} target="_blank">
                                                            <img className="wd-30 ht-30 rounded-circle" width={'50px'} height={'50px'} src={`../../../${item.cover}`} alt={item.cover} />
                                                        </a>
                                                    ) : (
                                                        <span className="badge bg-danger">Null</span>
                                                    )}
                                                    </td>
                                                    <td>{item.priority}</td>
                                                    <td>
                                                        <span type="button" className="badge bg-warning mx-2" data-toggle="modal" data-target={`#update${item.id}`}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                                                        </span>
                                                        <div className="dialog-box-wrapper form-dialog half-width">
                                                            <div className="modal fade text-left" id={`update${item.id}`} tabIndex={-1} role="dialog" aria-labelledby={`update${item.id}`} aria-hidden="true">
                                                                <div className="modal-dialog modal-dialog-centered" role="document">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header ">
                                                                            <h4>Add</h4>
                                                                            <button type="button" className="btn text-danger" data-dismiss="modal">X</button>
                                                                        </div>
                                                                        <form className="form-sample" onSubmit={(e) => {
                                                                            e.preventDefault();
                                                                            const formData = new FormData(e.target);
                                                                            const data = Object.fromEntries(formData);
                                                                            axios.put(`/categoryapi/${item.id}`, data).then(res => {
                                                                                if (res.data !== 'err') {
                                                                                    window.$(`#update${item.id}`).modal('hide');
                                                                                    getCategoryContent();
                                                                                }
                                                                            })
                                                                        }}>
                                                                            <div className="modal-body">
                                                                                <div className="form-group">
                                                                                    <label htmlFor="name_krd">Kurdish Name</label>
                                                                                    <input id="name_krd" className="form-control" type="text" name="name_krd" defaultValue={item.name_krd} required placeholder="ناوی کەتیگۆری" />
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label htmlFor="name_ar">Arabic Name</label>
                                                                                    <input id="name_ar" className="form-control" type="text" name="name_ar" defaultValue={item.name_ar} required placeholder="فئات" />
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label htmlFor="name_en">English  Name</label>
                                                                                    <input id="name_en" className="form-control" type="text" name="name_en" defaultValue={item.name_en} required placeholder="Category" />
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <label htmlFor="priority">Priority</label>
                                                                                    <input id="priority" className="form-control" defaultValue={item.priority} type="number" name="priority" required placeholder="Priority" />
                                                                                </div>
                                                                                <div className="mb-3">
                                                                                    <label> Image Icon</label>
                                                                                    <input type="hidden" defaultValue={item.cover} name="cover" required id="attachment" />
                                                                                    <div className="form-control text-center" onClick={() => upload()}>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                                                                                    </div>
                                                                                    <br />
                                                                                    <div align="center" id="upattachment"></div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="modal-footer">
                                                                                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                                                                                <button type="submit" className="btn btn-success">Save</button>
                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>

                                                </tr >
                                            ) : null
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </section>
                <FooterAdmin />
            </div>
        </>
    );
}
export default Category